import { create } from "zustand";

export interface NotiStore {
	total: number;
}

export const INITIAL_STATE = {
	total: 0,
};

export const useNotiStore = create<NotiStore>(() => ({
	...(INITIAL_STATE as NotiStore),
}));
